/* eslint-disable no-unused-vars */
import { useCallback, useEffect, useState, useTransition } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { updatedCart } from '../../features/updatedCartSlice';
import { addToCart } from '../../features/usercartSlice';
import { getFromLocalStorage } from '../helper/authorizationHelper';
import { getAsync, postAsync, reactURL } from '../helper/axiosHelper';
import { HeadingSection } from './headingSection';
import copy from 'copy-to-clipboard';
import LoadingAnimation from '../LoadingAnimation';
import LoaderModal from '../common/LoaderModal';
import ModalCartSuccessful from './ModalCartSuccessfull';
import ProjectsCard from './ProjectsCard';

const TabCards = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [newTab, setNewTab] = useState(false);
  const [projectApiData, setProjectAPIData] = useState([]);
  const [value, setValue] = useState([]);
  const [isPending, startTransition] = useTransition();
  const [activeTab, setActiveTab] = useState(0);
  const [amount, setAmount] = useState(0);
  const [errorStates, setErrorStates] = useState([]);
  const [projectTypes, setProjectTypes] = useState([]);
  const [modalMessageText, setModalMessageText] = useState('');
  const [modalExist, setModalExist] = useState(false);
  const [gridModalOpen, setGridModalOpen] = useState(false);
  const [epUserID, setEpUserID] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdatedValue, setIsUpdatedValue] = useState(false);
  const [id, setId] = useState('');

  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');

  const options = {
    pageno: 1,
    pagesize: 3,
  };

  const getProjectTypes = async () => {
    await getAsync(`APIClient/HomePageProjectTypes`)
      .then((res) => {
        const result = res?.data;
        setProjectTypes(result);
      })
      .catch((err) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    localStorage.setItem('isHome', true);
    getProjectTypes();
    handleTabClick(0, 'defd7f3e-d246-4550-820e-4ad3232095fa');
  }, []);

  const handleTabClick = useCallback(
    async (index, id) => {
      setNewTab(true);
      setActiveTab(index);
      setId(id);
      startTransition(async () => {
        try {
          const response = await getAsync(
            `APIClient/HomePageProjects?CategoryTypeId=${id}&page=${options.pageno}&pageSize=${options.pagesize}`,
          );
          setProjectAPIData(response?.data);
          setNewTab(false);
        } catch (error) {
          toast.error(t('Something went wrong, Please try again!'));
        }
      });
    },
    [t, startTransition], // Include startTransition in dependencies
  );

  useEffect(() => {
    if (token && epUserID != null) {
      (async () => {
        const response = await postAsync(`Cart/GetCartListByEpUserIdAndIP`, { EPUserID: epUserID });
        setValue(response?.data);
        dispatch(addToCart(response?.data));
      })();
    }
  }, [epUserID]);

  const initializeErrorStates = () => {
    const initialErrors = projectApiData.map(() => false);
    setErrorStates(initialErrors);
  };

  useEffect(() => {
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });
    initializeErrorStates();
  }, [projectApiData]);

  if (token) {
    document.querySelectorAll('.myButton').forEach((button) => {
      button.addEventListener('click', async function () {
        this.disabled = true;
        setTimeout(function () {
          this.disabled = false;
        }, 1000);
      });
    });
  }

  const dataObject = {
    paymentMethodId: 1,
    amount,
    required: true,
  };
  const updateErrorState = (index, isError) => {
    setErrorStates((prevStates) => {
      const newErrorStates = [...prevStates];
      newErrorStates[index] = isError;
      return newErrorStates;
    });
  };

  // new code
  const [dataValue, setDataValue] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [count, setCount] = useState(1);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [previousIndex, setPreviousIndex] = useState(currentIndex);
  const [smsModal, setSmsModal] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const [paymentMethodId, setPaymentMethodId] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      setValue(null);
      setLoading(true);
      try {
        const response = await fetch(`${baseURL}/APIClient/InternalProjectSHJC?ModuleId=${id}`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const result = await response.json();
        setValue(result);
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };

    if (id) {
      fetchData();
    }
  }, [id]);

  useEffect(() => {
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });
  }, [epUserID]);

  useEffect(() => {
    if (value?.data && value?.data?.length > 0) {
      setSelectedValues(Array(value?.data?.length).fill(1));
    }
  }, [value?.data]);

  // Function to handle donation
  const DonateHandle = (currentIndex, i, id, price, referralLink,isContribution,projectTypeIdInt) => {
    let selectedAmount = currentIndex !== i ? price : amount;

    if (selectedAmount > 0) {
      if (selectedAmount == 0) {
        updateErrorState(isContribution, true);
        return;
      } else {
        updateErrorState(isContribution, false);
        const payload = {
          ...dataObject,
          amount: selectedAmount,
          isContribution,
        };
        const link = `/externalPayment/${id}/${referralLink}/6/${projectTypeIdInt}`;
        navigate(link, { state: { paymentInfo: payload } });
      }
    } else {
      toast.error(`${t('Amount must be greater than 0')}`);
    }
  };

  if (loading) return <LoadingAnimation imageStyling={''} styling={'h-screen'} />;

  const addCartItem = async (currentIndex, i, price, pId,projectTypeIdInt) => {
    try {
      let selectedAmount = currentIndex !== i ? price : amount;

      if (selectedAmount > 0) {
        if (selectedAmount !== 0) {
          setIsLoading(true);
          const res = await postAsync(`Cart/GetCartListByEpUserIdAndIP`, { EPUserID: epUserID });
          dispatch(addToCart(res?.data));
          const response = await postAsync(`APIClient/ProjectListGUID`, [
            { ProjectId: pId, ProjectTypeIdInt: projectTypeIdInt },
          ]);
          if (response) {
            setIsLoading(false);
          }
          const newItem = response?.data;
          const cartbody = {
            cartID: 0,
            projectName: newItem[0]?.titleAr || newItem[0]?.titleEn,
            epUserID: epUserID,
            ip: 'string',
            projectID: newItem[0]?.id,
            amount: selectedAmount,
            projectTypeIdInt

          };
          if (token && res?.statusCode === 204) {
            await postAsync(`Cart/CreateCart`, cartbody);
            const resp = await postAsync(`Cart/GetCartListByEpUserIdAndIP`, { EPUserID: epUserID });
            dispatch(addToCart(resp?.data));
            dispatch(updatedCart(true));
            setModalMessageText('Add to cart Successfully');
            setModalExist(false);
            setGridModalOpen(true);
            return;
          } else if (res.data?.length && res?.statusCode === 200) {
            const itemExistsdatabase = res?.data?.some((item) => item.projectID === pId);

            if (token && !itemExistsdatabase) {
              await postAsync(`Cart/CreateCart`, cartbody);
              const respo = await postAsync(`Cart/GetCartListByEpUserIdAndIP`, {
                EPUserID: epUserID,
              });
              dispatch(addToCart(respo?.data));
              dispatch(updatedCart(true));
              setModalMessageText('Add to cart Successfully');
              setModalExist(false);
              setGridModalOpen(true);
            } else {
              setModalMessageText('Item  Already Exists');
              setModalExist(true);
              setGridModalOpen(true);
            }
          }

          if (!token) {
            const updateCart = (data) => {
              const updatedData = data.map((item) => {
                if (item?.id === newItem[0].id) {
                  return { ...item, price: selectedAmount };
                }
                return item;
              });
              localStorage.setItem('cart', JSON.stringify(updatedData));
            };

            // Retrieve existing cart data or create an empty array
            const existingData = JSON.parse(localStorage.getItem('cart')) || [];
            // Check if item exists and update price if needed
            const itemExists = existingData.some((item) => item?.id === newItem[0]?.id);
            if (itemExists) {
              setModalMessageText('Item  Already Exists');
              setModalExist(true);
              setGridModalOpen(true);
              updateCart(existingData);
            } else {
              // toast.success('Add to cart Successfully');
              dispatch(updatedCart(true));
              newItem[0].price = selectedAmount;
              updateCart([...existingData, ...newItem]);
              setModalMessageText('Add to cart Successfully');
              setModalExist(false);
              setGridModalOpen(true);
            }
          }
        }
      } else {
        toast.error(`${t('Amount must be greater than 0')}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleShareLink = (guid,projectTypeIdInt) => {
    setIsLoading(true);
    const shareLink = `${reactURL}/PaymentProcess/` + guid + '/' + guid + '/' + 6 + '/' + projectTypeIdInt;
    copy(shareLink);
    toast.success(t('Link copy Successfully'));
    setIsLoading(false);
  };

  const handleOnChange = (index, value) => {
    const newSelectedValues = [...selectedValues];
    newSelectedValues[index] = value;
    setSelectedValues(newSelectedValues);
    setPaymentMethodId(value);
  };

  return (
    <section className=" ">
      <HeadingSection headingStyle={'text-black'} title="Our Projects" />
      {newTab ? (
        <LoadingAnimation imageStyling={''} styling={'flex items-center py-5 align-middle justify-center space-x-2'} />
      ) : (
        <>
          <div className="text-lg font-medium text-center text-gray-500 border-b border-gray-200 dark:text-gray-400 ">
            <div>
              <div>
                <div data-aos="fade-down " data-aos-once="true" className="flex justify-center cur ">
                  {projectTypes?.map((data, index) => {
                    return (
                      <button
                        key={index}
                        className={`inline-block active bg-gray-100 hover:text-gray-600 border-gray-300 transition-colors text-customgreen hover:border-customgreen  rounded-t-lg py-1 sm:px-4 sm:w-40 max-[638px]:text-sm max-[638px]:w-32 text-lg max-[638px]:px-2 font-medium text-center  ${activeTab === index ? 'bg-gray-200   border-t-8 !border-customgreen' : 'bg-gray-100 text-gray-800'}  `}
                        onClick={() => handleTabClick(index, data?.id)}
                      >
                        {isActive ? data?.nameAr : data?.nameEn}
                      </button>
                    );
                  })}
                </div>
                <div>
                  {(activeTab === 0 || 1 || 2 || 3) && (
                    <div>
                      <div id="myTabContent">
                        <div
                          className="bg-gray-200 py-4 rounded-lg  "
                          id="profile"
                          role="tabpanel"
                          aria-labelledby="profile-tab"
                        >
                          {projectApiData?.length > 0 ? (
                            <div className="row px-4 sm:px-5 md:px-5 lg:px-5  justify-center">
                              {projectApiData?.map((data, index) => {
                                return (
                                  <ProjectsCard
                                    key={index}
                                    i={index}
                                    data={data}
                                    handleOnChange={handleOnChange}
                                    handleShareLink={handleShareLink}
                                    addCartItem={addCartItem}
                                    DonateHandle={DonateHandle}
                                    previousIndex={previousIndex}
                                    setPreviousIndex={setPreviousIndex}
                                    setCurrentIndex={setCurrentIndex}
                                    setCount={setCount}
                                    setAmount={setAmount}
                                    amount={amount}
                                    count={count}
                                    currentIndex={currentIndex}
                                    errorStates={errorStates}
                                    isLoading={isLoading}
                                    selectedValues={selectedValues}
                                    setSmsModal={setSmsModal}
                                    isUpdatedValue={isUpdatedValue}
                                    setIsUpdatedValue={setIsUpdatedValue}
                                  />
                                );
                              })}
                            </div>
                          ) : (
                            <LoadingAnimation />
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {
        <ModalCartSuccessful
          modalMessageText={modalMessageText}
          modalExist={modalExist}
          setGridModalOpen={setGridModalOpen}
          gridModalOpen={gridModalOpen}
        />
      }
      {isLoading && <LoaderModal />}
    </section>
  );
};

export default TabCards;
